import {
  useLayoutEffect,
  useRef,
  type CSSProperties,
  type ReactNode,
  type RefObject,
} from "react";
import { cn } from "@/lib/cn";
import { MORPH_MS, REVEAL_EASE } from "@/lib/reveal-motion";
import "./disclosure-panel.css";

/** The published accordion recipe, on Denker's shared resize clock. */
export function DisclosurePanel({
  id,
  open,
  children,
  className,
  returnFocusRef,
}: {
  id: string;
  open: boolean;
  children: ReactNode;
  className?: string;
  returnFocusRef?: RefObject<HTMLButtonElement | null>;
}) {
  const panelRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (!open && panelRef.current?.contains(document.activeElement))
      returnFocusRef?.current?.focus({ preventScroll: true });
  }, [open, returnFocusRef]);
  return (
    <div
      ref={panelRef}
      id={id}
      className={cn("denker-disclosure-panel", className)}
      data-testid={id}
      data-open={open ? "true" : "false"}
      aria-hidden={!open}
      inert={!open}
      style={
        {
          "--denker-disclosure-duration": `${MORPH_MS}ms`,
          "--denker-disclosure-ease": REVEAL_EASE,
        } as CSSProperties
      }
    >
      <div className="denker-disclosure-inner">{children}</div>
    </div>
  );
}
